import { useEffect, useRef } from 'react'

const listeners = new Map()
let data = {
	rect: null,
	innerWidth: 0,
	innerHeight: 0,
}

class IframePosition {
	static get data() {
		return data
	}

	static set data(value) {
		data = value
		listeners.forEach(listener => listener(data))
	}

	subscribe(listener) {
		const key = +new Date()
		listeners.set(key, listener)
		setTimeout(() => {
			listener(this.constructor.data)
		}, 40)

		return () => {
			listeners.delete(key)
		}
	}
}

window.addEventListener('message', event => {
	try {
		if (event.data.iframe) {
			IframePosition.data = event.data.iframe
		}
		// eslint-disable-next-line no-empty
	} catch (e) {}
})

const useIframePosition = (listener, active = true) => {
	const positionRef = useRef(null)
	return useEffect(() => {
		if (!active) return undefined
		const handleChangeIframePosition = position => {
			positionRef.current = position
			listener(position)
		}
		const handleResizeIframe = () => {
			if (!positionRef.current) return
			listener(positionRef.current)
		}
		const unsubscribe = new IframePosition().subscribe(handleChangeIframePosition)

		window.addEventListener('resize', handleResizeIframe)

		return () => {
			unsubscribe()
			window.removeEventListener('resize', handleResizeIframe)
		}
	}, [listener, active])
}

export default useIframePosition
